import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { getAPIBaseURL } from "../services/helpers"
import { postData } from "../services/request"

const NewRequest = () => {
  const navigate = useNavigate()
  const [message, setMessage] = useState("")
  const [btnState, setBtnState] = useState("Submit request")
  const [error, setError] = useState("")
  const [genMsg, setGenMsg] = useState("")

  const validate = () => {
    if(!message || message.trim().length < 10){
      setError("Message must be at least 10 characters")
      return false
    }
    if(message.length > 5000){
      setError("Message must not exceed 5000 characters")
      return false
    }
    setError("")
    return true
  }

  const submit = async () => {
    setGenMsg("")
    if(!validate()) return
    setBtnState("Submitting...")
    const url = `${getAPIBaseURL()}/v1/posts`
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    const params = new URLSearchParams()
    params.append('message', message)
    const res = await postData(url, headers, params.toString())
    setBtnState("Submit request")
    if(res.error == ""){
      if(res.result.status === 200 || res.result.status === 201){
        setGenMsg(res.result.data?.message || 'Request created')
        navigate('/dashboard/requests')
      }else{
        setError(res.result.data?.message || 'Could not create request')
      }
    }else{
      setError(res.result?.data?.message || 'Network error')
    }
  }

  return (
    <div className="mx-auto max-w-3xl px-3 sm:px-0">
      <div className="rounded-lg bg-white shadow-sm border border-gray-200">
        <div className="border-b border-gray-200 bg-gray-50 px-4 py-4 sm:px-6 sm:py-6">
          <h2 className="text-lg font-semibold text-gray-900 sm:text-2xl">New Medical Request</h2>
          <p className="mt-1 text-sm text-gray-600">Describe what you need. Hospitals will respond with prices.</p>
        </div>
        <div className="p-4 sm:p-6">
          {genMsg ? <div className="mb-4 rounded-lg border border-green-200 bg-green-50 p-3 text-sm font-medium text-green-700">{genMsg}</div> : null}
          {error ? <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-700">{error}</div> : null}
          <label htmlFor="message" className="mb-2 block text-sm font-semibold text-gray-900">Message</label>
          <textarea id="message" value={message} onChange={(e)=>setMessage(e.target.value)} rows="6" className="block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 transition-colors focus:border-black focus:outline-none focus:ring-2 focus:ring-black" placeholder="Describe your medical need in detail..." />
          <div className="mt-4">
            <button onClick={()=>submit()} type="button" className="w-full rounded-lg bg-black px-6 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2">{btnState}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewRequest


